import axios from 'axios';

const domain = window.location.hostname;
var url = '';

switch (domain)
{
  case 'localhost':
    url = 'http://localhost:81';
    break;
  case 'demo.vascularclass.it':
    url = 'https://test.gestione.vascularclass.it';
    break;
  case 'www.vascularclass.it':
  case 'vascularclass.it':
    url = 'https://gestione.vascularclass.it';
    break;

}

const axiosInstance = axios.create({
  baseURL: url + '/api',
  headers: {
    'Content-type': 'application/json',
  }
});

export default axiosInstance;